import { useState, useRef, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import WPSTubesheetGeneral from "./WPSTubesheetGeneral";
import WPSTubesheetProcedureSpec from "./WPSTubesheetProcedureSpec";
import { useLocation } from "react-router-dom";
import { getbyprojectno } from "../../Services/wps_groove-services";
import { getdetailsById } from "../../Services/wps_details-service";
import { WPSHeader } from "./WPSObjects/WPSGroove_entity";
import { DisableFields } from "./WPSObjects/WPSCommonUtils";
import { GridLoader } from "react-spinners";
import { MessageTypes, Action, Status } from "../utility/common/constants/CommonConstants";
import { NavigationButtons } from "../utility/ui/navigation/TransactionNavigation/NavigationButtons";
import { showToast, executeChildFunction, handleNavigation, setupBeforeUnloadListeners } from "../utility/ui/navigation/TransactionNavigation/TransactionUtils";


const WPSTubesheetTransaction = () => {
  const [key, setKey] = useState(1);

  const firstChildRef = useRef();
  const secondChildRef = useRef();
  const location = useLocation()
  const [loading, setLoading] = useState(true);
  const [action, setAction] = useState(location.state?.action);
  const [originalaction] = useState(location.state?.action);
  const [WPStype] = useState(location.state?.WPStype);
  const [IsEditedPage1, setIsEditedPage1] = useState(false);
  const [IsEditedPage2, setIsEditedPage2] = useState(false);
  const [isBtnDisabled, setBtnDisabled] = useState("");
  const [isReadonly, setReadOnly] = useState(false)
  const [headerObj, setheaderObj] = useState(
    action === Action.ActionEdit || action === Action.ActionCopy
      ? location.state?.data
      : WPSHeader(WPStype)
  );

  const [detailObj, setdetailObj] = useState([]);

  useEffect(() => {
    if (action === Action.ActionAdd) {
      let temparray = createDetailObj(1);
      setdetailObj(temparray);
    }
  }, []);

  function createDetailObj(start) {
    const temparray = [];
    for (let i = start; i <= 1; i++) {
      temparray.push({
        SK: "",
        PK: "",
        WPSH_Project_No: "",
        WPSH_WPS_No: "",
        WPSD_Process: "GTAW",
        WPSD_FM_SFA: "",
        WPSD_FM_Classification: "",
        WPSD_FM_FNo: "",
        WPSD_FM_Ano: "",
        WPSD_FM_ChemicalAnalysis_TradeName: "",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
        WPSD_WP_WeldingProcess: "GTAW",
        WPSD_WP_Type: "",
        WPSD_WP_MinimumPreheatTemp: "",
        WPSD_WP_MaximumInterpassTemp: "",
        WPSD_WP_PostHeating: "",
        WPSD_WP_TungstenType: "",
        WPSD_WP_WeldPosition: "",
        WPSD_WP_WeldProgression: "",
        WPSD_WP_NoofPasses: "",
        WPSD_WP_LayerNumber: [],
        WPSD_WP_FillerMetalSIze: [],
        WPSD_WP_ItemCode: [],
        WPSD_WP_BatchNumber: [],
        WPSD_WP_Amperes: [],
        WPSD_WP_Pulsing_current: [],
        WPSD_WP_Pulsing_current_others: [],
        WPSD_WP_Volts: [],
        WPSD_WP_TravelSpeed: [],
        WPSD_WP_HeatInput: [],
        WPSD_WP_CurrentPolarity: [],
        WPSD_WP_ArcVoltageControl: "",
        WPSD_WP_ShieldingGasType: "",
        WPSD_WP_ShieldingFlowRate: "",
        WPSD_WP_BackingGasType: "",
        WPSD_WP_BackingFlowRate: "",
        WPSD_WP_AuxiGasShieldSystem: "",
        status: "Active",
        wld_WPSType: WPStype,
        welddesc: [],
        weldweight: []
      });
    }
    return temparray;
  }

  const fetchprojectbyid = async (IdprojectPK, IdprojectSK) => {
    const result = await getbyprojectno("Tubesheet", IdprojectPK, IdprojectSK);
    setheaderObj(result[0]);
  };

  const fetchbyid = async (IddetailPK, IddetailSK) => {
    const result = await getdetailsById(IddetailPK, IddetailSK);
    if (action !== Action.ActionAdd) {
      let len = result?.length; //1
      let loop = 1 - len;

      let temparray1 = [];
      if (loop > 0) {
        temparray1 = createDetailObj(len + 1);

        setdetailObj([...result, ...temparray1]);
      } else {
        setdetailObj([...result]);
      }
    }
  };

  useEffect(() => {
    const loadData = async () => {
      if (action !== Action.ActionAdd) {
        let IdprojectPK = location.state?.data.WPSH_Project_No;
        let IdprojectSK = location.state?.data.WPSH_WPS_No;

        await fetchprojectbyid(IdprojectPK, IdprojectSK);
        setheaderObj(prev => ({
          ...prev,
          WPSH_UpdatedBy: new Date().toLocaleDateString("en-GB"),
          WPSH_UpdatedOn: sessionStorage.getItem("User")
        }));
        await fetchbyid(IdprojectPK, IdprojectSK);
      }
      setLoading(false);
    };
    loadData();
  }, []);

  useEffect(() => {
    return setupBeforeUnloadListeners([IsEditedPage1, IsEditedPage2]);
  }, [IsEditedPage1, IsEditedPage2]);

  useEffect(() => {
    let read = DisableFields(headerObj.WPSH_Status, headerObj.WPSH_Prepared_By, Status, Action, action);
    if (action === Action.ActionCopy)
      setBtnDisabled("");
    else if (read)
      setBtnDisabled("disabled");
    else
      setBtnDisabled("");
    setReadOnly(read);
  }, [action]);

  const next = async (e) => {
    const refs = [firstChildRef, secondChildRef];
    const funcNames = ['funcOnNext', 'funcOnNext'];
    const funcName = funcNames[key - 1];
    const res = await executeChildFunction(refs, key, funcName);
    showToast(res, key, setKey, 2, true);
  };

  const handleSelect = (e) => {
    Temp(e, "tab");
  };

  const Temp = async (e, tabaction) => {
    const refs = [firstChildRef, secondChildRef];
    const funcNames = ['funcOnNextTemp1', 'funcOnNextTemp'];
    const funcName = funcNames[key - 1];
    const res = await executeChildFunction(refs, key, funcName);

    showToast(res, key, setKey, 2, true);

    if (res === MessageTypes.Temp || res === MessageTypes.None) {
      handleNavigation(tabaction, e, key, setKey, 2);
    }
  };

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <div className="position-absolute ms-3" style={{ top: "15px" }}>
        <strong>Add New</strong>
        <span className="ms-1 warning-text" style={{ fontSize: "small" }}>
          (All fields are mandatory)
        </span>
      </div>
      <div className="border-divider" />
      <div className="mt-4">
        <div style={{ borderBottom: "2px solid var(--col-ddd)", position: "relative", top: "34px", zIndex: "-2" }}></div>
        <Tabs
          activeKey={key}
          onSelect={(e) => handleSelect(e)}
          className="mb-2 w-100 border-end"
          fill
        >
          <Tab
            eventKey={1}
            title="WPS - Page 1 ( Tube to Tubesheet)"
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <WPSTubesheetGeneral
              ref={firstChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              WPStype={WPStype}
              setKey={setKey}
              tabno={key}
              setIsEditedPage1={setIsEditedPage1}
              isReadonly={isReadonly}
              setReadOnly={setReadOnly}
              setAction={setAction}
              action={action}
            />
          </Tab>
          <Tab
            eventKey={2}
            title="WPS-Page 2"
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            disabled={action === Action.ActionAdd ? true : false}
          >
            <WPSTubesheetProcedureSpec
              ref={secondChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              WPStype={WPStype}
              setKey={setKey}
              tabno={key}
              setIsEditedPage2={setIsEditedPage2}
              setBtnDisabled={setBtnDisabled}
              isReadonly={isReadonly}
              setReadOnly={setReadOnly}
              setAction={setAction}
              action={action}
            />
          </Tab>
        </Tabs>
        <NavigationButtons
          currentKey={key}
          maxTabs={2}
          isBtnDisabled={isBtnDisabled}
          originalAction={originalaction}
          onNext={next}
          onTemp={Temp}
        />
      </div>
    </>
  )
};

export default WPSTubesheetTransaction;
